import { useEffect, useState } from 'react';
import { qualityCheckServices } from '../../../services/qualityCheck';
import { canOpenCorrections, seesStudyWideCorrections, StudyAccess } from './correctionAccess';

/**
 * SKIN-600 — the visits whose open correction flag is assigned to the caller, for the patient
 * page to offer the correction tools on those visits only (`mayCorrectVisit`).
 *
 * Asked only of a corrector without Quality Check (the dermatologist): an APPROVE_VISIT holder
 * may correct every SUBMITTED visit, so its answer is not needed and `null` is returned. Also
 * `null` while the list is on its way or could not be read — nothing is offered then.
 */
export function useOwnOpenFlagVisits(uuidInvestigation: string | undefined, study: StudyAccess | null | undefined): ReadonlySet<string> | null {
    const needed = !!uuidInvestigation && canOpenCorrections(study) && !seesStudyWideCorrections(study);
    const [visits, setVisits] = useState<ReadonlySet<string> | null>(null);

    useEffect(() => {
        setVisits(null);
        if (!needed || !uuidInvestigation) return undefined;
        let cancelled = false;
        qualityCheckServices.listOpenCorrections(uuidInvestigation).then(
            ({ flags }) => { if (!cancelled) setVisits(new Set(flags.map((flag) => flag.visitUuid))); },
            () => undefined,
        );
        return () => { cancelled = true; };
    }, [needed, uuidInvestigation]);

    return visits;
}
